const isNumericInput = (event) => {
	const key = event.keyCode;
	return ((key >= 48 && key <= 57) || // Allow number line
		(key >= 96 && key <= 105) // Allow number pad
	);
};

const isModifierKey = (event) => {
	const key = event.keyCode;
	return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
		(key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
		(key > 36 && key < 41) || // Allow left, up, right, down
		(
			// Allow Ctrl/Command + A,C,V,X,Z
			(event.ctrlKey === true || event.metaKey === true) &&
			(key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
		)
};

export const enforceFormat = (event) => {
	// Input must be of a valid number format or a modifier key, and not longer than ten digits
	if(!isNumericInput(event) && !isModifierKey(event)){
		event.preventDefault();
	}
};

export const formatToPhone = (event) => {
	if(isModifierKey(event)) {return;}

	// I am lazy and don't like to type things more than once
	const target = event.target;
	const input = event.target.value.replace(/\D/g,'').substring(0,10); // First ten digits of input only
	const zip = input.substring(0,3);
	const middle = input.substring(3,6);
	const last = input.substring(6,10);

	if(input.length > 6){target.value = `(${zip}) ${middle}-${last}`;}
	else if(input.length > 3){target.value = `(${zip}) ${middle}`;}
	else if(input.length > 0){target.value = `(${zip}`;}
};

//if (data===null || data==='') return ''
export const formatToPhoneData = (data) => {

	const input = data.replace(/\D/g,'').substring(0,10); // First ten digits of input only
	const zip = input.substring(0,3);
	const middle = input.substring(3,6);
	const last = input.substring(6,10);

	const formatted = `(${zip}) ${middle} - ${last}`
	return formatted
}

// const inputElement = document.getElementById('contactPhone');
// inputElement.addEventListener('keydown',enforceFormat);
// inputElement.addEventListener('keyup',formatToPhone);

/**
 * Normalizes a phone number to E.164 format.
 * @param {string} phoneNumber The phone number in any format.
 * @param {string} defaultCountryCode The default country code to prepend if not present.
 * @returns {string} The phone number in E.164 format.
 */
export function normalizePhoneNumber(phoneNumber, defaultCountryCode = '+1') {
	// Strip everything except digits. NOTE: this removes any leading '+', so we can't
	// detect an existing country code by looking for '+' after this point — the old
	// version did, which is why it always re-prepended '+1' and produced '+11XXXXXXXXXX'.
	const digits = (phoneNumber || '').replace(/\D/g, '');

	// Drop a leading country-code '1' if present (handles 1XXXXXXXXXX and, after the
	// strip above, the digits of +1XXXXXXXXXX), leaving the 10-digit national number.
	const national = (digits.length === 11 && digits.startsWith('1'))
		? digits.slice(1)
		: digits;

	// Only a valid 10-digit US number gets a country code. Anything else is returned
	// unchanged so a malformed value fails Cognito's validation loudly rather than
	// being disguised as '+1' + garbage.
	if (national.length !== 10) {
		return phoneNumber;
	}

	return `${defaultCountryCode}${national}`;
}